var exports = {
  "D": "x112a1f60--b6f6af--title",
  "t": "x112a1f60--b6f6af--title--link-block",
};

module.exports = exports;
